import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { OrganizationService } from './organization.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private permissionSignal = signal<{ [organizationId: string]: boolean }>({});
  private baseUrl = `${environment.smartPortalApiUrl}Organization`;

  constructor(private msalService: MsalService, private http: HttpClient, private organizationService: OrganizationService) {

    // React to organizationId changes
    this.organizationService.organizationId$.subscribe(organizationId => {
      if (organizationId) {
        this.checkPermission(organizationId);
      }
    });
  }

  hasElevatedPermission(organizationId: string): boolean {
    return this.permissionSignal()[organizationId] ?? false;
  }

  private updatePermission(organizationId: string, hasPermission: boolean) {
    this.permissionSignal.update(perms => ({
      ...perms,
      [organizationId]: hasPermission,
    }));
  }

  private checkPermission(organizationId: string) {

    const account = this.msalService.instance.getActiveAccount();
    if (!account || !account.idTokenClaims) {
      this.updatePermission(organizationId, false);
      return;
    }

    const userGroups = (account.idTokenClaims['groups'] as string[]) || [];
    if (!userGroups.length) {
      // Handle missing groups claim (e.g., group overage)
      this.updatePermission(organizationId, false);
      return;
    }

    // Fetch the configured AAD group ID for the organization
    this.http
      .get<any>(`${this.baseUrl}/${organizationId}/group-config`)
      .subscribe({
        next: groupConfig => {          
          const hasPermission = groupConfig.isICSAdmin ||  
            groupConfig.groupId === null ||  groupConfig.groupId !== null && userGroups.includes(groupConfig.groupId);
          
          this.updatePermission(organizationId, hasPermission);
        },
        error: () => {
          this.updatePermission(organizationId, false);
        },
      });      
  }

}
